import {ApiResponse} from '../models/ApiResponse';
import {Project} from '../models/Projects/Project';
import {apiClient} from './baseApiClient';

class ProjectApi {
  public async getProjects(
    organizationId: string,
  ): Promise<ApiResponse<Project[]>> {
    return apiClient.get(`/project/${organizationId}/list`);
  }

  public async getProject(
    organizationId: string,
    projectId: string,
  ): Promise<ApiResponse<Project>> {
    return apiClient.get(`/project/${organizationId}/${projectId}`);
  }

  public async createProject(
    organizationId: string,
    name: string,
  ): Promise<ApiResponse<{projectId: string}>> {
    return apiClient.post(`/project/${organizationId}`, {name});
  }

  public async editProject(
    organizationId: string,
    projectId: string,
    name: string,
  ): Promise<ApiResponse<any>> {
    return apiClient.put(`/project/${organizationId}/${projectId}`, {name});
  }

  public async deleteProject(
    organizationId: string,
    projectId: string,
  ): Promise<ApiResponse<any>> {
    return apiClient.delete(`/project/${organizationId}/${projectId}`);
  }

  public async assignCourses(
    organizationId: string,
    projectId: string | null,
    courseIds: string[],
  ): Promise<ApiResponse<any>> {
    return apiClient.put(`/project/${organizationId}/assign`, {
      projectId,
      courseIds,
    });
  }
}

export default ProjectApi;
